import "@main/styles/global.css"
import { startMSW } from "./src/mswInit"
import { DynamicRecaptchaProvider } from "./src/presentation/shared/components/wrapper-recaptcha/WrapperRecaptcha"

import { RootElement } from "./src/root"

export const wrapRootElement = ({ element }) => {
  startMSW()

  return (
    <RootElement>
      <DynamicRecaptchaProvider>
        {element}
      </DynamicRecaptchaProvider>
    </RootElement>
  )
}

export const onClientEntry = () => {
  if (
    process.env.GATSBY_MAINTENANCE === "1" &&
    !window.location.pathname.includes("/mantenimiento")
  ) {
    window.location.href = "/mantenimiento"
  }
}

/**
 * Ejecuta pageVisit de Synerise en cada cambio de ruta (navegación).
 * Gatsby dispara este callback en la carga inicial y en cada cambio de ruta.
 *
 * En una SPA, los cambios de ruta no generan recargas de página,
 * así que es necesario detectar cada navegación manualmente.
 */
export const onRouteUpdate = ({ location, prevLocation }) => {
  // Verificar que Synerise está disponible
  if (!window.SR?.event?.pageVisit) {
    console.warn(
      "[Synerise] SDK no está disponible. Verifica que el script se cargó correctamente"
    )
    return
  }

  // No ejecutar si es la misma ruta (no debería pasar, pero por seguridad)
  if (prevLocation && prevLocation.pathname === location.pathname) {
    return
  }

  try {
    // Disparar pageVisit y obtener contenido dinámico
    window.SR.event.pageVisit()
      .then(() => {
        if (window.SR?.dynamicContent?.get) {
          return window.SR.dynamicContent.get()
        }
      })
      .catch((error) => {
        console.error("[Synerise] Error al disparar pageVisit:", error)
      })
  } catch (error) {
    console.error("[Synerise] Error inesperado:", error)
  }
}
